import { defineComponent as _defineComponent } from 'vue'
import { useUtil } from '@/plugins/util'
import { useAuthStore } from '@/store/pinia/auth'
import { usePhysicianStore } from '@/store/pinia/physician'
import AppMenuButton from '@/v2/components/ui/menu/AppMenuButton.vue'
import * as amplitude from '@amplitude/analytics-browser'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectSuport',
  setup(__props) {

const authStore = useAuthStore()

const util = useUtil()
const physicianStore = usePhysicianStore()
function saveClickAnalytics(button: string) {
  const userData = util.prepareAnalyticsUserProperties(physicianStore)
  amplitude.track('Clique em ajuda', {
    button: button,
    buttonTitle: button,
    ...userData,
  })
}

function openWhatsapp() {
  saveClickAnalytics('whatsapp')
  const message = `Olá me chamo ${authStore.session!.user.name}, estou na plataforma Bioplanner e preciso de ajuda.`

  const link = `https://api.whatsapp.com/send?phone=5511998933332&text=${message}&lang=pt_br`
  window.open(link, '_blank')
}

function goToHelpCenter() {
  saveClickAnalytics('help-center')
  window.open('https://www.notion.so/Kintsu-s-Help-Center-434b8199a5854f0aacb0cf94505d897d?pvs=24', '_blank')
}

return { __sfc: true,authStore, util, physicianStore, saveClickAnalytics, openWhatsapp, goToHelpCenter, AppMenuButton }
}

})